export const colorMap = {
  Red: "#f05a72",
  Purple: "#9d85be",
  Yellow: "#fecc4e",
  Orange: "#faa74a",
  Blue: "#2ac4f4",
  Green: "#3db97b",
} as Record<string, string>
